import { useState } from "react";
import { Box, Button, CloseButton, Dialog, Portal, Text, VStack } from "@chakra-ui/react";

/**
 * Step 1 of "create a recruitment as an admin": pick which of the client's
 * scenarios the new recruitment inherits from. Mirrors the client app, where a
 * recruitment is always created from a scenario (so its scoring model /
 * inherited criteria have a source). `scenarios` is the client's assigned
 * scenario list already loaded by ClientDetailPage.
 */
const CreateRecruitmentDialog = ({ scenarios = [], onClose, onPick }) => {
    const [selectedId, setSelectedId] = useState(null);

    return (
        <Dialog.Root open onOpenChange={(e) => !e.open && onClose()} placement="center">
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content bg="bg.card" borderWidth={1} borderColor="border.secondary" borderRadius={12} p={2} minW={96} maxW="lg">
                        <Dialog.Header>
                            <Dialog.Title color="white">Nowa rekrutacja</Dialog.Title>
                            <Dialog.CloseTrigger asChild>
                                <CloseButton color="white" size="sm" />
                            </Dialog.CloseTrigger>
                        </Dialog.Header>
                        <Dialog.Body>
                            <Text color="text.grey" fontSize="sm" mb={3}>
                                Wybierz scenariusz, na którym oprze się rekrutacja.
                            </Text>
                            {scenarios.length === 0 ? (
                                <Text color="text.grey" fontSize="sm" py={4} textAlign="center">
                                    Ten klient nie ma przypisanego żadnego scenariusza. Przypisz scenariusz przed dodaniem rekrutacji.
                                </Text>
                            ) : (
                                <VStack align="stretch" gap={2} maxH="360px" overflowY="auto">
                                    {scenarios.map((s) => {
                                        const isSelected = selectedId === s.id;
                                        return (
                                            <Box
                                                key={s.id}
                                                as="button"
                                                type="button"
                                                textAlign="left"
                                                onClick={() => setSelectedId(s.id)}
                                                px={4}
                                                py={3}
                                                borderRadius={8}
                                                border="1px solid"
                                                borderColor={isSelected ? "purple.500" : "border.primary"}
                                                bg={isSelected ? "purple.900" : "bg.secondary"}
                                                _hover={{ borderColor: isSelected ? "purple.500" : "border.secondary" }}
                                                transition="border-color 0.15s, background 0.15s"
                                            >
                                                <Text color="white" fontSize="sm" fontWeight={500}>{s.name}</Text>
                                                {s.agent?.name && (
                                                    <Text color="text.grey" fontSize="xs" mt={0.5}>{s.agent.name}</Text>
                                                )}
                                            </Box>
                                        );
                                    })}
                                </VStack>
                            )}
                        </Dialog.Body>
                        <Dialog.Footer>
                            <Button variant="outlined" onClick={onClose}>Anuluj</Button>
                            <Button
                                variant="primary"
                                disabled={!selectedId}
                                onClick={() => onPick(selectedId)}
                            >
                                Dalej
                            </Button>
                        </Dialog.Footer>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};

export default CreateRecruitmentDialog;
